export const ISLANDS = [
  "New Providence", "Grand Bahama", "Abaco", "Andros", "Eleuthera", "Exuma",
  "Cat Island", "Long Island", "Bimini", "Berry Islands", "Inagua",
  "Acklins", "Crooked Island", "Mayaguana", "Ragged Island", "San Salvador", "Other",
];

export const COUNTRIES = [
  "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda",
  "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahrain",
  "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan",
  "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria",
  "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada",
  "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros",
  "Congo (Brazzaville)", "Congo (Kinshasa)", "Costa Rica", "Croatia", "Cuba",
  "Cyprus", "Czechia", "Denmark", "Djibouti", "Dominica", "Dominican Republic",
  "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia",
  "Eswatini", "Ethiopia", "Fiji", "Finland", "France", "Gabon", "Gambia",
  "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea",
  "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hungary", "Iceland", "India",
  "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", "Jamaica", "Japan",
  "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kuwait", "Kyrgyzstan", "Laos",
  "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania",
  "Luxembourg", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta",
  "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova",
  "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia",
  "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria",
  "North Korea", "North Macedonia", "Norway", "Oman", "Pakistan", "Palau", "Panama",
  "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal",
  "Qatar", "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia",
  "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe",
  "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore",
  "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa",
  "South Korea", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden",
  "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand",
  "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey",
  "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates",
  "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu",
  "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe",
];

export const CONTACT_METHODS = ["Call", "WhatsApp", "Email"];

export const SERVICE_NAMES = [
  "Construction Surveying", "Topographical Surveys", "Grading & Slope Analysis",
  "Volume Calculations", "Building Layouts", "Project As-Builts",
  "Plan Production", "Legal Descriptions", "Surveying Reports",
];

export const SERVICE_OPTIONS = [...SERVICE_NAMES, "Other"];

export const PROJECT_TYPES = [
  "Residential", "Commercial", "Road/Civil Works", "Utilities",
  "Renovation/Extension", "Other",
];

export const WORK_REQUIRED = [
  "Building Corners", "Foundation/Footing Layout", "Structural Elements",
  "Control Points", "Elevation Checks", "Road/Utility Alignment",
  "Boundary Reference", "Unsure",
];

export const CONSTRUCTION_STAGES = [
  "Pre-construction / Planning", "Site Clearing", "Foundation", "Framing / Structure",
  "Mid-construction", "Finishing", "As-built / Completed",
];

export const STATUSES = [
  "New", "Under Review", "Quote Sent", "Awaiting Approval",
  "Scheduled", "Completed", "Declined",
];

export const INQUIRY_STATUSES = ["New", "Responded", "Follow-Up Required", "Closed"];

export const INQUIRY_STATUS_STYLES = {
  "New": "bg-[#eef6ff] text-[#1d63ed] border-[#b8d5ff]",
  "Responded": "bg-[#ecfdf5] text-[#047857] border-[#a7f3d0]",
  "Follow-Up Required": "bg-[#fff8e6] text-[#b27b00] border-[#ffe399]",
  "Closed": "bg-[#f3f4f6] text-[#4b5563] border-[#d1d5db]",
};

export const STATUS_STYLES = {
  "New": "bg-[#eef6ff] text-[#1d63ed] border-[#b8d5ff]",
  "Under Review": "bg-[#fff8e6] text-[#b27b00] border-[#ffe399]",
  "Quote Sent": "bg-[#f3e8ff] text-[#7e22ce] border-[#d8b4fe]",
  "Awaiting Approval": "bg-[#fff1f2] text-[#be123c] border-[#fecdd3]",
  "Scheduled": "bg-[#ecfdf5] text-[#047857] border-[#a7f3d0]",
  "Completed": "bg-[#f0fdf4] text-[#15803d] border-[#bbf7d0]",
  "Declined": "bg-[#fef2f2] text-[#b91c1c] border-[#fecaca]",
};

export const ACCEPTED_TYPES = ".pdf,.doc,.docx,.jpg,.jpeg,.png";

export const PROJECT_CATS = [
  { cat: "construction", service: "Construction Surveying", title: "Construction Surveying", type: "Residential Build", island: "New Providence" },
  { cat: "topographical", service: "Topographical Surveys", title: "Topographical Survey", type: "Site Assessment", island: "Abaco" },
  { cat: "grading", service: "Grading & Slope Analysis", title: "Grading & Slope", type: "Civil Works", island: "Grand Bahama" },
  { cat: "volume", service: "Volume Calculations", title: "Volume Calculations", type: "Earthworks", island: "Eleuthera" },
  { cat: "building", service: "Building Layouts", title: "Building Layout", type: "Commercial", island: "New Providence" },
  { cat: "asbuilt", service: "Project As-Builts", title: "Project As-Built", type: "Completed Structure", island: "Exuma" },
  { cat: "plan", service: "Plan Production", title: "Plan Production", type: "Documentation", island: "New Providence" },
  { cat: "legal", service: "Legal Descriptions", title: "Legal Descriptions", type: "Property Records", island: "Andros" },
  { cat: "report", service: "Surveying Reports", title: "Surveying Report", type: "Technical Review", island: "Long Island" },
];

export const PROJECT_DETAIL_FIELDS = [
  { key: "title", label: "Title", multiline: false },
  { key: "type", label: "Project Type", multiline: false },
  { key: "island", label: "Island / Location", multiline: false },
  { key: "overview", label: "Project Overview", multiline: true },
  { key: "requirement", label: "Client's Requirement", multiline: true },
  { key: "work_completed", label: "Surveying Work Completed", multiline: true },
  { key: "deliverables", label: "Deliverables Provided", multiline: true },
];
